//Generator Url: http://localhost:8033/api/UserWeChatSetup/getapi
import request from '~/utils/request';
//import './UserWeChatSetupApi.d';
export namespace UserWeChatSetupApi {
    /**获取微信绑定会话信息*/
    export const get = (param: Partial<IUserWeChatSetupGetParam>, loadingOptions?: IRequestLoadingOption) => request<IUserWeChatSetupResult>({
        method: 'post',
        url: 'UserWeChatSetup/Get',
        data: param,
        loadingOptions
    })

    /**创建微信绑定会话*/
    export const createSession = (loadingOptions?: IRequestLoadingOption) => request<IUserWeChatSetupResult>({
        method: 'post',
        url: 'UserWeChatSetup/CreateSession',
        loadingOptions
    })

    /**用户绑定微信*/
    export const bind = (param: IUserWeChatSetupBindParam, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'UserWeChatSetup/Bind',
        data: param,
        loadingOptions
    })

    /**用户使用微信绑定会话登录*/
    export const signIn = (param: IUserWeChatSetupSignInParam, loadingOptions?: IRequestLoadingOption) => request<void>({
        method: 'post',
        url: 'UserWeChatSetup/SignIn',
        data: param,
        loadingOptions
    })

    // ------------ model define ------------- //


    export interface IUserWeChatSetupResult {
        /**会话Id
        *System.Guid*/
        Id: string
        /**用户Id
        *System.Int32*/
        UserId: number
        /**手机号
        *System.String*/
        Mobile?: NString

        UserName?: NString
        /**创建时间
        *System.DateTime*/
        Created?: NString
        /**过期时间
        *System.DateTime*/
        Expires?: NString
        /**完成时间
        *System.Nullable`1[System.DateTime]*/
        Completed?: NString
        /**标识会话已过期
        *System.Boolean*/
        IsExpired: boolean
        /**微信确认链接
        *System.String*/
        ConfirmUrl?: NString
    }


    export interface IUserWeChatSetupGetParam {

        Id: string

        Scan: boolean
    }


    export interface IUserWeChatSetupBindParam {

        Id: string
    }


    export interface IUserWeChatSetupSignInParam {

        Id: string
    }

}
export default UserWeChatSetupApi